import React from 'react';
import moment from 'moment';

import { getStatusColor } from 'common/jobConstants';

import SrBox from 'client/components/SrBox';
import SrCard from 'client/components/SrCard/SrCard';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrSunSetupListingOrderDetail from 'client/components/SrSunSetupListingOrders/SrSunSetupListingOrder/SrSunSetupListingOrderDetail';
import SrSunSetupListingOrderJob from 'client/components/SrSunSetupListingOrders/SrSunSetupListingOrder/SrSunSetupListingOrderJob';
import SrPartnerList from 'client/components/SrPartnerList';
import SrLink from 'client/components/SrLink/SrLink';

const SrSunSetupListingOrder = ({
  listing,
  jobOrder,
}) => {
  const jobsWithDriverNotes = (jobOrder.jobs || [])
    .filter(({ driverNotes }) => !!driverNotes);
  const editBackUrl = global.encodeURIComponent(`/sunsetup/listing-orders/${listing.id}`);

  return (
    <SrCard
      margin='0 0'
    >
      <SrBox
        position='relative'
      >
        <SrText
          font='greycliff'
          fontSize='21px'
          weight='800'
        >
          Order # {jobOrder.id}
        </SrText>
        <SrBox
          position='absolute'
          right='0'
          top='2px'
        >
          <SrLink
            to={`/sunsetup/orders/edit/${jobOrder.id}?backUrl=${editBackUrl}`}
            color='blue300'
          >
            Edit
          </SrLink>
        </SrBox>
      </SrBox>
      <SrFlex
        marginTop='16px'
        justify='between'
      >
        <SrSunSetupListingOrderDetail
          title='Due Date'
          subtitle={moment(jobOrder.dueDate).format('MMM DD') || 'Missing due date'}
          maxWidth='24%'
        />
        <SrSunSetupListingOrderDetail
          title='Status'
          subtitle={jobOrder.status}
          subtitleColor={getStatusColor(jobOrder.status)}
          maxWidth='24%'
        />
        <SrSunSetupListingOrderDetail
          title='Driver'
          subtitle={jobOrder.driverName || 'Unknown'}
          maxWidth='24%'
        />
        <SrSunSetupListingOrderDetail
          title='Submitted by'
          subtitle={jobOrder.requestedBy || 'Sunroom API'}
          maxWidth='24%'
        />
      </SrFlex>
      <SrBox
        marginTop='24px'
      >
        <SrBox
          marginBottom='-15px'
        >
          <SrText
            font='greycliff'
            fontSize='18px'
            weight='800'
          >
            Jobs
          </SrText>
        </SrBox>
        <SrBox
          padding='0px 8px'
        >
          <SrPartnerList twoColumns>
            {(jobOrder.jobs || []).map((job) => (
              <SrSunSetupListingOrderJob
                key={job.id}
                job={job}
                listing={listing}
                showPhotos
              />
            ))}
          </SrPartnerList>
        </SrBox>
      </SrBox>
      <SrBox
        marginTop='16px'
        maxWidth='300px'
      >
        <SrBox>
          <SrText
            weight='800'
            fontSize='16px'
          >
            Order Instructions
          </SrText>
        </SrBox>
        <SrBox
          width='100%'
        >
          <SrText
            font='greycliff'
            weight='600'
            fontSize='14px'
            whiteSpace='prewrap'
          >
            {jobOrder.instructions || 'No instructions provided.'}
          </SrText>
        </SrBox>
      </SrBox>

      {jobsWithDriverNotes.length > 0 && (
        <SrBox
          marginTop='16px'
          maxWidth='300px'
        >
          <SrBox>
            <SrText
              weight='800'
              fontSize='16px'
            >
              Driver Notes
            </SrText>
          </SrBox>
          <SrBox
            width='100%'
          >
            {jobsWithDriverNotes.map((job, index) => (
              <SrBox paddingTop={index === 0 ? null : '16px'} key={job.id}>
                <SrSunSetupListingOrderJob
                  job={job}
                  listing={listing}
                />
                <SrText
                  font='greycliff'
                  weight='600'
                  fontSize='14px'
                  whiteSpace='prewrap'
                >
                  {job.driverNotes}
                </SrText>
              </SrBox>
            ))}
          </SrBox>
        </SrBox>
      )}
    </SrCard>
  );
};

SrSunSetupListingOrder.displayName = 'SrSunSetupListingOrder';

export default SrSunSetupListingOrder;
